import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import RelaxModel from "Base/model/RelaxModel";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import {TweenMax, Linear} from "gsap";

export default class BaseMobileAutoPlayPanelContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this._enabled = true;

        this.isOpen = false;
        this.mode = 2;
        this.checkBoxes = [];

        this.baseX = this.x;
        this.basey = this.y;

        this.init();
        this.addActions();
        this.addListeners();
        this.createTweens();
        this.close();
    }

    init() {
        this.content = this.getChildByName('content');
        this.openCloseButton = this.content.getChildByName('openCloseButton');
        this.openCloseButton.enabled = true;

        for (let i = 1; i <= 3; i++) {
            let checkBox = this.content.getChildByName('count_' + i);
            let count = EntryPoint.AutoPlaySettings.possibleCounts[i - 1];
            checkBox.value = count;
            //checkBox.checked = checkBox.value === EntryPoint.AutoPlaySettings.selectedCount;
            checkBox.enabled = !checkBox.checked;
            checkBox.actions = {
                checked: {
                    callback: this.onCountChecked, context: this, params: checkBox
                }
            };
            if (count > RelaxModel.maxAutoplayCount) {
                checkBox.visible = false;
            } else {
                this.checkBoxes.push(checkBox);
            }
        }
    }

    addActions() {
        this.openCloseButton.actions = {
            checked: {
                callback: this.onOpenCloseChecked, context: this
            },
            unchecked: {
                callback: this.onOpenCloseUnchecked, context: this
            }
        }
    }

    addListeners() {
        GlobalDispatcher.add('autoPlaySettings:activeChanged', this.onAutoPlayActiveChanged, this);
        GlobalDispatcher.add('ui:spinClick', this.onSpinClick, this);
        //GlobalDispatcher.add('autoPlaySettings:countChanged', this.onAutoPlayCountChanged, this);
    }

    createTweens() {
        this.openTween = TweenMax.to(this.content, 0.1, {y:0, ease:Linear.easeNone, paused:true});
        this.closeTween = TweenMax.to(this.content, 0.1, {y:-340, ease:Linear.easeNone, paused:true});
    }

    onCountChecked(data) {
        EntryPoint.AutoPlaySettings.selectedCount = data.value;
        if (this.mode === 1) {
            EntryPoint.AutoPlaySettings.active = true;
        }
        this.setChecked();
    }

    setChecked() {
        this.checkBoxes.forEach((checkBox, index) => {
            checkBox.checked = checkBox.value === EntryPoint.AutoPlaySettings.selectedCount;
            checkBox.enabled = !checkBox.checked;
        });
    }

    setMode(value) {
        this.mode = value;
        if(this.mode === 1) {
            this.reset();
        } else {
            this.setChecked();
        }
    }

    reset() {
        this.checkBoxes.forEach((checkBox, index) => {
            checkBox.checked = false;
            checkBox.enabled = true;
        });
    }

    setEnabled(value) {
        this.checkBoxes.forEach((checkBox, index) => {
            checkBox.enabled = value;
        });
    }

    onOpenCloseChecked(data) {
        GlobalDispatcher.dispatch('ui:openAutoPlayPopup', true);
        this.open();
    }

    onOpenCloseUnchecked(data) {
        GlobalDispatcher.dispatch('ui:openAutoPlayPopup', false);
        this.close();
    }

    onAutoPlayActiveChanged(event) {
        this.openCloseButton.enabled = !event.params;
        if (event.params && this.isOpen) {
            this.close();
        }
    }

    onSpinClick(event) {
        if (this.isOpen) {
            this.close();
        }
    }

    open() {
        this.reset();
        this.isOpen = true;
        this.openCloseButton.checked = this.isOpen;
        this.closeTween.pause();
        this.openTween.play(0);
    }

    close() {
        this.setEnabled(false);
        this.isOpen = false;
        this.openCloseButton.checked = this.isOpen;
        this.openTween.pause();
        this.closeTween.play(0);
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        this.setEnabled(this._enabled);
        this.openCloseButton.enabled = this.enabled;
    }
}